"use strict";

require("@patsnap-ui/design-tokens/scss/utils/_popper.scss");

require("./dropdown.scss");